import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css'
import AiAgent from './pages/AiAgent/AiAgent';
import Call_Logs from './pages/Call_Logs/Call_Logs';
import Activities from './pages/Activities/Activities';
import Login from './pages/Login/Login';
import PrivateRoutes from './Components/PrivateRoutes';
import Settings from './pages/Settings/Settings';
import Signup from './pages/Signup/Signup';
import ForgotPassword from './pages/Login/ForgetPassword';
import EmailVerification from './pages/Login/EmailVerification';
import UpdatePassword from './pages/Login/NewPassword';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SkeletonLoader from './Components/Skelton';
import Users from './pages/UsersandRole/UsersHolder';
import Folders from './pages/AiAgent/folders';
import LLMConfigs from './pages/Configurations/LLMConfig';
import VoiceConfigs from './pages/Configurations/VoiceConfig';
import PaymentHistory from './pages/PaymentHistory/PaymentHistory';
import TranscriberConfigs from './pages/Configurations/TranscriberConfig';
import SingleCall from './pages/Calling/SingleCall';
import BulkCall from './pages/Calling/BulkCall';
import Invoice from './pages/PaymentHistory/Invoice';
import Customerinfo from './pages/Usercallogs/Customerinfo';
import Consentfile from './pages/Call_Logs/Consentfile';
import PhoneNumbers from './pages/Calling/PhoneNumbers';
import Ivr from './pages/Ivr';
import WorkFlow from './pages/WorkFlow';
import CreateIVR from './pages/CreateIVR';
import CreateWorkFlow from './pages/CreateWorkFlow';
import AudioPlayer from './pages/AudioPlayer';
import Integrations from './pages/Integrations';
import CreateIntegration from './pages/CreateIntegration';
// import SelectedNumbers from './pages/Calling/SelectedNumbers';
// import NumberBuying from './pages/Calling/NumberBuying';




// Lazy-loaded Private Components

const Dashboard = lazy(() => import("./pages/Dashboard/Dashboard"));
const AgentCreation = lazy(() => import("./pages/AgentCreation/AgentCreation"));
const Plans = lazy(() => import("./pages/Plans/Plans"));
const Support = lazy(() => import('./pages/Support/Support'));
const UserCallLogs = lazy(() => import('./pages/Usercallogs/usercalllogs'));
const SelectedNumbers = lazy(() => import('./pages/Calling/SelectedNumbers'));
const NumberBuying = lazy(() => import('./pages/Calling/NumberBuying'));
// const Consentfile = lazy(() => import('./Components/Consentfile'));


function App() {
  return (
    <div className="App authentication-bg pb-0" >
      <ToastContainer />
      <Router>
        <Routes>
          <Route path="/" element={<Login />} />s
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/verify-email" element={<EmailVerification />} />
          <Route path="/newpassword/:uid/:token" element={<UpdatePassword />} />
          <Route
            path="/callconsent/:token1/:token2/:companyName"
            element={<Consentfile />}
          />
          <Route element={<PrivateRoutes />}>
            <Route path="/dashboard" element={
              <Suspense fallback={<SkeletonLoader type="dashboard" />}>
                <Dashboard />
              </Suspense>
            } />
            <Route path="/agentcreation" element={
              <Suspense fallback={<SkeletonLoader type="agent_creation" />}>
                <AgentCreation />
              </Suspense>
            } />
            <Route path="/ai_agent" element={<AiAgent />} />
            <Route path="/ivr" element={<Ivr/>} />
            <Route path="/workflow" element={<WorkFlow />} />
            <Route path="/users" element={<Users />} />
            <Route path="/folders" element={<Folders />} />
            <Route path="/llmconfigurations" element={<LLMConfigs />} />
            <Route path="/voiceconfigurations" element={<VoiceConfigs />} />
            <Route path="/transcriberconfigurations" element={<TranscriberConfigs />} />
            <Route path="/paymenthistory" element={<PaymentHistory />} />
            <Route path="/invoice" element={<Invoice />} />
            <Route path="/singlecall" element={<SingleCall />} />
            <Route path="/bulkcall" element={<BulkCall />} />
            <Route path="/usercalllogs" element={<UserCallLogs />} />
            <Route path="/customerprofile/:customerId" element={<Customerinfo />} />
            <Route path="/call_logs" element={<Call_Logs />} />
            <Route path="/activities" element={<Activities />} />
            <Route path="/numberbuying" element={<NumberBuying />} />
            <Route path="/selectednumbers" element={<SelectedNumbers />} />
            <Route path='/phonenumbers' element={<PhoneNumbers />} />
            <Route path='/create-ivr' element={<CreateIVR/>}/>
            <Route path='/create-workflow' element={<CreateWorkFlow/>}/>
            <Route path='/audio' element={<AudioPlayer/>}/>
            <Route path='/integrations' element={<Integrations/>}/>
            <Route path='/create-integration' element={<CreateIntegration/>}/>




            <Route path="/plans" element={
              <Suspense fallback={<SkeletonLoader type="plans" />}>
                <Plans />
              </Suspense>
            } />
            <Route path="/user-profile" element={
              <Suspense fallback={<SkeletonLoader type="settings" />}>
                <Settings />
              </Suspense>
            } />
            <Route path="/support" element={
              <Suspense fallback={<SkeletonLoader type="support" />}>
                <Support />
              </Suspense>
            } />
          </Route>

        </Routes>

      </Router>
    </div>
  );
}

export default App;
